import type {
  PaymentInfoProps,
  ExtendedPaymentInfoFormData,
} from '@openeducation/pp-rn-shared-types';
import { PaymentMethod } from '@openeducation/pp-rn-shared-types';

export interface ValidatePaymentInfoParams {
  fields: PaymentInfoProps['fields'];
  validation: PaymentInfoProps['validation'];
  formData: ExtendedPaymentInfoFormData;
}

export const validatePaymentInfo = ({
  fields,
  validation,
  formData,
}: ValidatePaymentInfoParams) => {
  const isCountryOk =
    fields.isCountryEnabled && !fields.isExistingPaymentMethod
      ? !!formData.country
      : true;
  const isPaymentMethodOk = !!formData.paymentMethod;

  const isCard1TypeOk = fields.isCardTypeEnabled
    ? !!validation.isCard1TypeValid
    : true;
  const isCard1NumberOk = fields.isCardNumberEnabled
    ? !!validation.isCard1NumberValid
    : true;
  const isCard1ExpirationOk = fields.isExpirationDateEnabled
    ? !!validation.isCard1ExpirationValid
    : true;
  const isCard1HolderNameOk = fields.isHolderNameEnabled
    ? !!validation.isCard1HolderNameValid
    : true;
  const isCard1CvvOk =
    fields.isCvvEnabled && !fields.isExistingPaymentMethod
      ? !!validation.isCard1CvvValid
      : true;
  const isCard1InstallmentsOk = fields.isInstallmentsEnabled
    ? !!formData.card1_installments
    : true;
  const isCard1AmountOk =
    formData.paymentMethod === PaymentMethod.TWO_CREDIT_CARDS
      ? !!validation.isCard1AmountValid
      : true;

  const card1IsValid =
    isCard1TypeOk &&
    isCard1NumberOk &&
    isCard1ExpirationOk &&
    isCard1HolderNameOk &&
    isCard1CvvOk &&
    isCard1InstallmentsOk &&
    isCard1AmountOk;

  let card2IsValid = true;

  if (formData.paymentMethod === PaymentMethod.TWO_CREDIT_CARDS) {
    const isCard2TypeOk = fields.isCardTypeEnabled
      ? !!validation.isCard2TypeValid
      : true;
    const isCard2NumberOk = fields.isCardNumberEnabled
      ? !!validation.isCard2NumberValid
      : true;
    const isCard2ExpirationOk = fields.isExpirationDateEnabled
      ? !!validation.isCard2ExpirationValid
      : true;
    const isCard2HolderNameOk = fields.isHolderNameEnabled
      ? !!validation.isCard2HolderNameValid
      : true;
    const isCard2CvvOk =
      fields.isCvvEnabled && !fields.isExistingPaymentMethod
        ? !!validation.isCard2CvvValid
        : true;
    const isCard2InstallmentsOk = fields.isInstallmentsEnabled
      ? !!formData.card2_installments
      : true;

    card2IsValid =
      isCard2TypeOk &&
      isCard2NumberOk &&
      isCard2ExpirationOk &&
      isCard2HolderNameOk &&
      isCard2CvvOk &&
      isCard2InstallmentsOk;
  }

  return isCountryOk && isPaymentMethodOk && card1IsValid && card2IsValid;
};
